enum SubmissionMode {
	Individual = "individual",
	Simultaneous = "simultaneous",
}

export default SubmissionMode;
